import { observer } from 'mobx-react-lite'
import { type BreakerQuestionAnswerEditorViewModel } from '@/features/jobs/questions/breaker/BreakerQuestionAnswerEditorViewModel'
import { BreakerQuestionAnswerEditor } from './'

export interface BreakerQuestionAnswerEditorContainerProps {
  questionId: string
  editorVm: BreakerQuestionAnswerEditorViewModel
  isDisabled?: boolean
  'aria-label'?: string
  'aria-labelledby'?: string
}

export const BreakerQuestionAnswerEditorContainer = observer(
  function BreakerQuestionAnswerEditorContainer({
    editorVm,
    questionId,
  }: BreakerQuestionAnswerEditorContainerProps) {
    return (
      <BreakerQuestionAnswerEditor
        testId={`breaker-question-answer-editor-${questionId}`}
        backButtonTestId={`breaker-question-answer-editor-back-button-${questionId}`}
        onBackPress={editorVm.goBack}
      />
    )
  },
)
